import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.union([t.literal("shop"), t.literal("education"), t.literal("healthcare"), t.literal("leisure")]);

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);

type T = t.TypeOf<typeof codec>;
